import { render, staticRenderFns } from "./TextTemplate.vue?vue&type=template&id=d7a32bee&scoped=true"
import script from "./TextTemplate.vue.ts?vue&type=script&lang=ts&external"
export * from "./TextTemplate.vue.ts?vue&type=script&lang=ts&external"
import style0 from "./TextTemplate.vue?vue&type=style&index=0&id=d7a32bee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7a32bee",
  null
  
)

export default component.exports